import axios from "axios";
import type { IApp } from "@/types";

const defaultUsageApiBase = "https://e9whtxtp38.execute-api.us-west-2.amazonaws.com";

export interface FetchUsageRangeParams {
  startMonth: string;
  endMonth: string;
}

export async function fetchUsageRange(
  params: FetchUsageRangeParams
): Promise<IApp.IUsageRangeResponse> {
  const baseUrl =
    import.meta.env.VITE_USAGE_API_BASE_URL?.replace(/\/$/, "") ?? defaultUsageApiBase;
  const accountId = import.meta.env.VITE_USAGE_ACCOUNT_ID ?? "thor-ai-report";
  const product = import.meta.env.VITE_USAGE_PRODUCT ?? "thor-ai";
  const url = new URL("/usage/range", `${baseUrl}/`);
  url.searchParams.set("accountId", accountId);
  url.searchParams.set("startMonth", params.startMonth);
  url.searchParams.set("endMonth", params.endMonth);
  url.searchParams.set("product", product);
  const { data } = await axios.get<IApp.IUsageRangeResponse>(url.toString());
  return data;
}
